// that probably needs to be removed and replaced with logic in DdvDate
import { DdvDate } from '@ddv/models';

export const dateFormatter = {
    // I'm pretty sure that only strings ever get passed into this function in real code, but there are a lot of tests that don't
    asDisplayValue: (value: unknown, { input = 'MM/DD/YYYY', output = 'MM/DD/YYYY' }: { [key: string]: string } = {}): string => {
        let date: DdvDate;
        if (value instanceof Date) {
            date = DdvDate.fromDate(value);
        } else if (input === 'MM/DD/YYYY') {
            date = DdvDate.fromUSFormat(`${value}`);
        } else if (input === 'DD/MM/YYYY') {
            date = DdvDate.fromEUFormat(`${value}`);
        } else if (input === 'YYYY-MM-DD') {
            date = DdvDate.fromDashFormat(`${value}`);
        } else {
            date = DdvDate.fromUSFormat(`${value}`);
        }

        if (!date.isValid()) {
            return `${value}`;
        }

        return formatDdvDateOutput(date, output);
    },
    asFilterValue: (value: string): Date => {
        return DdvDate.fromDashFormat(value).toDate();
    },
};

function formatDdvDateOutput(date: DdvDate, output: string): string {
    switch (output) {
        case 'QTR':
            return date == null ? '' : `Q${date.quarter}`;
        case 'MMM':
            return date?.monthName ?? '';
        case 'DD':
            return date?.day == null ? '' : (date.day < 10 ? '0' : '') + date.day.toString();
        case 'MM/DD/YYYY':
            return date.toUSPaddedFormat();
        case 'M/D/YYYY':
            return date.toUSFormat();
        case 'YYYY-MM-DD':
            return date.toReversePaddedDashFormat();
        case 'MMM YYYY':
            return `${date.monthName} ${date.year}`;
        case 'DD/MM/YYYY':
            return date.toEUPaddedFormat();
        case 'YYYY':
            return date.year?.toString() ?? '';
        case 'MM/DD':
            return `${(date.month ?? 0) + 1}/${date.day}`;
        default:
            return '';
    }
}
